import React from 'react';

const ImpressumContent = () => {
  return (
    <>
      <section className='impressum-section ptb-120'>
        <div className='container'>
          <ul className='list-unstyled mb-0'>
            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Angaben gemäß § 5 TMG</h3>
                <p>elintech GmbH</p>
                <p>Textorstraße 10, 60594 Frankfurt am Main, Deutschland</p>
              </div>
            </li>
            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Geschäftsführer:</h3>
                <p>Edgar Linde</p>
              </div>
            </li>
            <li className='d-flex align-items-start mb-4 mb-lg-0'>
              <div className='icon-content'>
                <h3 className='h5'>Kontakt:</h3>
                <p>Telefon: +49 176 2422 4368</p>
                <p>
                  E-Mail: <a href='mailto:info@elintech.de'>info@elintech.de</a>
                </p>
              </div>
            </li>

            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Umsatzsteuer-ID:</h3>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß §27a
                  Umsatzsteuergesetz: DE359134732
                </p>
              </div>
            </li>

            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Steuernummer:</h3>
                <p>045 232 32290</p>
              </div>
            </li>

            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Handelsregistereintrag</h3>
                <p>Amtsgericht Frankfurt am Main HRB 129902</p>
              </div>
            </li>

            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>
                  Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO
                </h3>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur
                  Online-Streitbeilegung (OS) bereit, die Sie unter{' '}
                  <a
                    href='https://ec.europa.eu/consumers/odr/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    https://ec.europa.eu/consumers/odr/
                  </a>{' '}
                  finden. Unsere E-Mail-Adresse lautet: info@elintech.de.
                </p>
              </div>
            </li>

            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h3'>Haftungsausschluss:</h3>
                <p></p>
              </div>
            </li>
            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Haftung für Inhalte</h3>
                <p>
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt
                  erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität
                  der Inhalte können wir jedoch keine Gewähr übernehmen. Als
                  Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                  Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                  verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                  gespeicherte fremde Informationen zu überwachen oder nach
                  Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                  hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                  Nutzung von Informationen nach den allgemeinen Gesetzen
                  bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
                  jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
                  Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                  Rechtsverletzungen werden wir diese Inhalte umgehend
                  entfernen.
                </p>
              </div>
            </li>
            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                  deren Inhalte wir keinen Einfluss haben. Deshalb können wir
                  für diese fremden Inhalte auch keine Gewähr übernehmen. Für
                  die Inhalte der verlinkten Seiten ist stets der jeweilige
                  Anbieter oder Betreiber der Seiten verantwortlich. Die
                  verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                  mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren
                  zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
                  inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
                  konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
                  Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                  Links umgehend entfernen.
                </p>
              </div>
            </li>
            <li className='d-flex align-items-start mb-4'>
              <div className='icon-content'>
                <h3 className='h5'>Urheberrecht</h3>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                  diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                  Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                  Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
                  der schriftlichen Zustimmung des jeweiligen Autors bzw.
                  Erstellers. Downloads und Kopien dieser Seite sind nur für den
                  privaten, nicht kommerziellen Gebrauch gestattet. Soweit die
                  Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
                  werden die Urheberrechte Dritter beachtet. Insbesondere werden
                  Inhalte Dritter als solche gekennzeichnet. Sollten Sie
                  trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                  bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
                  von Rechtsverletzungen werden wir derartige Inhalte umgehend
                  entfernen.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default ImpressumContent;

